(function () {
  'use strict';
  if (window.AlatreyuPWYC) return;

  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }
  function money(n) { return '$' + n; }
  function money2(n) { return '$' + n.toFixed(2); }
  function navSecs() { return Math.round(performance.now() / 1000); }

  function bind(drawer, pwyc, o) {
    var secs = o.secs || navSecs;
    var amountEl = drawer.querySelector('[data-pwyc-amount]');
    var slider = drawer.querySelector('[data-pwyc-slider]');
    var atc = drawer.querySelector('[data-pwyc-atc]');
    var scroll = drawer.querySelector('[data-pwyc-scroll]');
    var value = pwyc.anchor;
    var gaThrottle;
    var tierChanges = 0;
    var sawCost = false;
    var handle = pwyc.handle || o.handle || '';

    var tiers = Object.keys(pwyc.prices)
      .map(function (k) { return parseInt(k, 10); })
      .filter(function (n) { return n > 0 && pwyc.prices[String(n)]; })
      .sort(function (a, b) { return a - b; });

    function idFor(v) { return pwyc.prices[String(v)] || 0; }
    function tierAt(i) { return tiers[Math.max(0, Math.min(tiers.length - 1, i))]; }

    var THUMB = 24;

    function positionAmount() {
      if (!amountEl || !slider) return;
      var min = parseFloat(slider.min);
      var max = parseFloat(slider.max);
      var w = slider.clientWidth;
      if (!w || max === min) return;
      var x = THUMB / 2 + ((parseFloat(slider.value) - min) / (max - min)) * (w - THUMB);
      var half = amountEl.offsetWidth / 2;
      amountEl.style.setProperty('--thumb-x', Math.max(half, Math.min(w - half, x)) + 'px');
    }

    var feeEl = drawer.querySelector('[data-cost-fee]');
    var totalEl = drawer.querySelector('[data-cost-total]');
    var feeRate = totalEl ? parseFloat(totalEl.getAttribute('data-fee-rate')) : NaN;
    var feeFixed = totalEl ? parseFloat(totalEl.getAttribute('data-fee-fixed')) : NaN;
    var costBase = totalEl ? parseFloat(totalEl.getAttribute('data-base')) : NaN;

    function paintCost(v) {
      if (!feeEl || !totalEl) return;
      if (isNaN(feeRate) || isNaN(feeFixed) || isNaN(costBase)) return;
      var fee = Math.round((v * feeRate + feeFixed) * 100) / 100;
      feeEl.textContent = money2(fee);
      totalEl.textContent = money2(costBase + fee);
    }

    function applyValue(v) {
      var id = idFor(v);
      if (!id) { if (atc) atc.disabled = true; return; }
      if (atc) atc.disabled = false;
      value = v;
      drawer.setAttribute('data-variant-id', id);
      if (slider) slider.setAttribute('aria-valuetext', money(v));
      if (amountEl) amountEl.textContent = money(v);
      positionAmount();
      paintCost(v);
      var atcPrice = atc && atc.querySelector('[data-pwyc-atc-price]');
      if (atcPrice) atcPrice.textContent = money(v);
      if (o.onApply) o.onApply(v, id);
    }

    function openDrawer() {
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      sawCost = true;
      ga('cost_transparency_opened', { product_handle: handle, seconds_on_page: secs() });
      paintFade();
      positionAmount();
      if (slider) slider.focus();
    }
    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      if (o.onClose) o.onClose();
    }

    drawer.querySelectorAll('[data-pwyc-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    if (slider) {
      slider.min = 0;
      slider.max = Math.max(0, tiers.length - 1);
      var anchorIndex = tiers.indexOf(pwyc.anchor);
      if (anchorIndex >= 0) {
        slider.value = anchorIndex;
        drawer.setAttribute('data-variant-id', idFor(pwyc.anchor));
      } else if (tiers.length) {
        slider.value = 0;
        applyValue(tiers[0]);
      }
      slider.addEventListener('input', function () {
        applyValue(tierAt(parseInt(slider.value, 10)));
        clearTimeout(gaThrottle);
        gaThrottle = setTimeout(function () {
          tierChanges += 1;
          ga('pwyc_tier_selected', {
            product_handle: handle,
            tier_price: value,
            tier_label: money(value),
            tier_change_count: tierChanges,
            seconds_on_page: secs(),
            saw_cost_breakdown: sawCost
          });
        }, 250);
      });
    }

    var FADE_ZONE = 130;
    var FADE_MIN = 0.12;
    var READ_MIN = 0.92;
    var fadeRows = scroll ? scroll.querySelectorAll('.al-cost__line, .al-cost__total') : [];
    var fadeTick;

    function paintFade() {
      if (!scroll || !fadeRows.length) return;
      var left = scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight;
      var strength = left <= 2 ? 0 : Math.min(1, left / FADE_ZONE);
      var edge = scroll.getBoundingClientRect().bottom;
      for (var i = 0; i < fadeRows.length; i++) {
        var row = fadeRows[i];
        var dist = edge - row.getBoundingClientRect().bottom;
        var op = 1;
        if (dist < FADE_ZONE) {
          op = FADE_MIN + (1 - FADE_MIN) * Math.max(0, dist) / FADE_ZONE;
          op = 1 - (1 - op) * strength;
          if (dist >= -1) op = Math.max(op, READ_MIN);
        }
        row.style.opacity = op.toFixed(3);
      }
    }

    if (scroll) {
      scroll.addEventListener('scroll', function () {
        if (fadeTick) return;
        fadeTick = requestAnimationFrame(function () { fadeTick = null; paintFade(); });
      });
      window.addEventListener('resize', function () { if (!drawer.hidden) { paintFade(); positionAmount(); } });
    }

    if (atc && o.add) {
      atc.addEventListener('click', function () {
        var id = idFor(value);
        if (!id) return;
        var params = {
          tier_price: value,
          tier_label: money(value),
          tier_change_count: tierChanges,
          seconds_to_add: secs(),
          saw_cost_breakdown: sawCost,
          currency: 'USD',
          value: value,
          items: [{
            item_id: pwyc.sku || o.sku || '',
            item_name: pwyc.title || o.title || '',
            item_brand: 'Alatreyu',
            price: value,
            quantity: 1
          }]
        };
        var extra = o.extra ? o.extra() : null;
        for (var k in extra) params[k] = extra[k];
        if (atc.disabled) return;
        atc.disabled = true;
        Promise.resolve(o.add(id)).then(function (ok) {
          if (ok !== false) ga('pwyc_add_to_cart', params);
        }, function () {}).then(function () { atc.disabled = !idFor(value); });
      });
    }

    return { open: openDrawer, close: closeDrawer };
  }

  var cache = {};
  var curList = {};
  var curBtn = null;

  function addId(id) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.innerHTML = '<input name="id"><input name="quantity" value="1">';
    f.elements.id.value = id;
    if (window.AlatreyuCart) return window.AlatreyuCart.add(f);
    document.body.appendChild(f); f.submit();
  }

  function quick(btn) {
    var handle = btn.getAttribute('data-handle');
    var list = btn.closest('[data-collection]');
    function attr(n) { return (list && list.getAttribute(n)) || btn.getAttribute(n) || ''; }
    curList = { item_list_id: attr('data-list-id'), item_list_name: attr('data-list-name') };
    curBtn = btn;
    ga('quick_pwyc_open', {
      item_id: btn.getAttribute('data-product-id') || '',
      item_name: btn.getAttribute('data-title') || '',
      item_list_id: curList.item_list_id
    });
    if (!cache[handle]) {
      btn.setAttribute('aria-busy', 'true');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var src = base + 'products/' + encodeURIComponent(handle) + '?section_id=quick-pwyc';
      cache[handle] = fetch(src)
        .then(function (r) {
          if (r.status !== 429) return r;
          return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return fetch(src); });
        })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var drawer = doc.querySelector('.al-pwyc__backdrop');
          var dataEl = doc.querySelector('[data-pwyc-data]');
          if (!drawer || !dataEl) throw new Error('no drawer');
          document.body.appendChild(drawer);
          if (window.AlatreyuFitName) window.AlatreyuFitName(drawer);
          var c = bind(drawer, JSON.parse(dataEl.textContent), {
            extra: function () { return curList; },
            add: function (id) { c.close(); return addId(id); },
            onClose: function () { if (curBtn && document.body.contains(curBtn)) curBtn.focus({ preventScroll: true }); }
          });
          return c;
        });
    }
    cache[handle].then(function (c) {
      btn.removeAttribute('aria-busy');
      c.open();
    }, function () {
      delete cache[handle];
      btn.removeAttribute('aria-busy');
      location.href = btn.getAttribute('data-url');
    });
  }

  window.AlatreyuPWYC = { bind: bind, quick: quick };
})();
